import { BJumbotron } from './jumbotron';
import { pluginFactory } from '../../utils/plugins';
var JumbotronPlugin = /*#__PURE__*/pluginFactory({
  components: {
    BJumbotron: BJumbotron
  }
});
export { JumbotronPlugin, BJumbotron };


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/components/jumbotron/index.js
// module id = /lqj
// module chunks = 3